import { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { useBuyer } from '../context/BuyerAuthContext';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';

export default function BuyerLoginPage() {
  const { buyer, login, checking } = useBuyer();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (checking) return null;
  if (buyer) return <Navigate to="/catalog" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back');
      navigate('/catalog');
    } catch (err) {
      toast.error(err.response?.data?.detail || err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBF8F3] px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#3D2817]/60 hover:text-[#C5A059] mb-10">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-3">— Reserved Access</div>
          <div className="font-serif text-4xl">Buyer Portal</div>
          <p className="mt-3 text-sm text-[#3D2817]/60">Personal terms and priority access for approved partners.</p>
        </div>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="text-xs uppercase tracking-widest text-[#3D2817]/60">Email</label>
            <input data-testid="buyer-email" required type="email" value={email} onChange={e => setEmail(e.target.value)} className="underline-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-[#3D2817]/60">Password</label>
            <input data-testid="buyer-password" required type="password" value={password} onChange={e => setPassword(e.target.value)} className="underline-input" />
          </div>
          <button data-testid="buyer-login-submit" disabled={loading} className="w-full mt-8 bg-[#3D2817] hover:bg-[#C5A059] text-white text-sm uppercase tracking-[0.25em] py-4 transition-all duration-500">
            {loading ? '...' : 'Enter Portal'}
          </button>
          <p className="text-xs text-[#3D2817]/50 text-center">
            No account yet? <Link to="/#quote" className="text-[#C5A059] hover:underline">Request one</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
